import React, { useState } from 'react';
import { PencilIcon, CheckIcon, XIcon, InfoIcon, UserIcon } from 'lucide-react';
import { LoanField } from '../types/loan';
interface FieldRowProps {
  field: LoanField;
  onChange: (id: string, value: string) => void;
}
export function FieldRow({
  field,
  onChange
}: FieldRowProps) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(field.value);
  const editable = field.editable !== false;
  const startEdit = () => {
    setDraft(field.value);
    setEditing(true);
  };
  const save = () => {
    onChange(field.id, draft);
    setEditing(false);
  };
  const cancel = () => {
    setDraft(field.value);
    setEditing(false);
  };
  const inputType = field.type === 'date' ? 'text' : field.type === 'currency' || field.type === 'percent' ? 'text' : 'text';
  return <div className="group relative border-b border-slate-200 py-2.5 px-3 transition-colors hover:bg-slate-50/80" data-id="element-71" data-mp="gx2u8aohiczv">
      <div className="flex items-start gap-2" data-id="element-72" data-mp="c3rne9jo9w7y">
        <div className="min-w-0 flex-1" data-id="element-73" data-mp="1s98mh9mqkox4">
          <div className="flex items-center gap-1.5" data-id="element-74" data-mp="1sa9x5czub9eb">
            <label className="text-[13px] font-medium text-slate-500" data-id="element-75" data-mp="1x7sadfkw4as4">{field.label}</label>
            {field.info && <span className="relative inline-flex" title={field.info} data-id="element-76" data-mp="1ijxh9y2z04ei">
                <InfoIcon className="h-3.5 w-3.5 cursor-help text-slate-400" aria-label={field.info} data-id="element-77" data-mp="1ni8nlyu23wrz" />
              </span>}
          </div>

          {editing ? <div className="mt-1 flex items-center gap-2" data-id="element-78" data-mp="19kk690z777ro">
              {field.type === 'boolean' ? <select autoFocus value={draft} onChange={e => setDraft(e.target.value)} className="w-full max-w-xs rounded border border-sky-400 bg-white px-2 py-1 text-sm text-slate-800 shadow-sm outline-none ring-2 ring-sky-100" data-id="element-79" data-mp="1ef7le98baptl">
                  <option value="" data-id="element-80" data-mp="2yx5ktw0e9saf">--None--</option>
                  <option value="Yes" data-id="element-81" data-mp="2ywm9wz95w45w">Yes</option>
                  <option value="No" data-id="element-82" data-mp="2xgroir951z0m">No</option>
                </select> : <input autoFocus type={inputType} value={draft} onChange={e => setDraft(e.target.value)} onKeyDown={e => {
            if (e.key === 'Enter') save();
            if (e.key === 'Escape') cancel();
          }} className="w-full max-w-md rounded border border-sky-400 bg-white px-2 py-1 text-sm text-slate-800 shadow-sm outline-none ring-2 ring-sky-100" data-id="element-83" data-mp="2shf1o6i9ory1" />}
              <button type="button" onClick={save} className="flex h-7 w-7 shrink-0 items-center justify-center rounded bg-sky-600 text-white transition-colors hover:bg-sky-700" aria-label="Save" data-id="element-84" data-mp="36fls51kvzpno">
                <CheckIcon className="h-4 w-4" data-id="element-85" data-mp="3u692rum6stdx" />
              </button>
              <button type="button" onClick={cancel} className="flex h-7 w-7 shrink-0 items-center justify-center rounded border border-slate-300 bg-white text-slate-500 transition-colors hover:bg-slate-100" aria-label="Cancel" data-id="element-86" data-mp="1gnuwo6zdvcba">
                <XIcon className="h-4 w-4" data-id="element-87" data-mp="1une4eyoa8ln2" />
              </button>
            </div> : <div className="mt-0.5 min-h-[20px] text-sm text-slate-800" data-id="element-88" data-mp="1zmz1t4nt0lxo">
              {field.value ? field.type === 'user' ? <span className="inline-flex items-center gap-1.5" data-id="element-89" data-mp="24k925fcqei0a">
                    <span className="flex h-4 w-4 items-center justify-center rounded bg-sky-100" data-id="element-90" data-mp="29ca9cmv1lijg">
                      <UserIcon className="h-3 w-3 text-sky-700" data-id="element-91" data-mp="2dedphosnpbb2" />
                    </span>
                    <a href="#" className="font-medium text-sky-700 hover:underline" data-id="element-92" data-mp="2ie00drl0ifgp">
                      {field.value}
                    </a>
                  </span> : <span data-id="element-93" data-mp="29p2qtngu325y">{field.value}</span> : <span className="text-slate-300" data-id="element-94" data-mp="24qhqlo1l0ihi">&mdash;</span>}
            </div>}
        </div>

        {editable && !editing && <button type="button" onClick={startEdit} className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded text-slate-400 opacity-0 transition-all hover:bg-slate-200 hover:text-slate-600 focus:opacity-100 group-hover:opacity-100" aria-label={`Edit ${field.label}`} data-id="element-95" data-mp="2jeurmzfj0riv">
            <PencilIcon className="h-3.5 w-3.5" data-id="element-96" data-mp="20omsesey6l7y" />
          </button>}
      </div>
    </div>;
}